import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {industryConst} from "./industryConst";
import DLLoader from "../core/components/DLLoader/DLLoader";
import IndustryView from "./IndustryView";
import {useParams} from "react-router-dom";
import {getAllIndustries, getFundSummary, getIndustrySummaryData} from "./IndustryAction";
import {isEmpty} from "../utils/validations";
import {
    getIndustryActivities,
    getStockActivities,
    getStockTrend,
    getStockTrendForIndustry
} from "../stocks/StocksActions";
import appTheme from "../assets/appTheme";
import {stocksConst} from "../stocks/stocksConst";
import moment from "moment";
import {getNetBuyingSellingPopUpData} from "./IndustryAction";
import FundView from "../fund/FundView";
import {filterNetBuyingSellingValue, getFixedValuesAfterDecimal} from "../utils/helper";


function Industry(props) {
    const [industryState,setIndustryState] = useState({
        activitiesStateLoaded: false,
        activitiesData: {},
        fundHouseCount : '',
        fundSchemeCount : '',
        marketValueChangeMoM: '',
        xAxis: [],
        yAxisBar: [],
        yAxisLine: [],
        barColor: [],
        tabValue: 0,
        isDomLoaded: false

    });

    const {sector} = useParams();

    const [UIState, setUIState] = useState();
    const [industries, setIndustries] = useState([]);
    const [selectedIndustry, setSelectedIndustry] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [popUpModalData,setPopUpModalData] = useState({
        requiredMonth : '',
        entries:[],
        exits:[],
        netBuying:0,
        netSelling:0,
        buyingFunds:0,
        sellingFunds:0,
        netBuyingSellingDifference:0,
        isModalApiInProgress: true
    })

    const handleOpenModal =(graphMonth,industry)=>{
        setIsModalOpen(true)
        getDataForPopUp(graphMonth,industry);
    }
    const handleCloseModal =()=>{
        setIsModalOpen(false)
        setTimeout(()=>{},200)
        initializeZeroCondition()
    }

    const initializeZeroCondition =()=>{

        setPopUpModalData((prevState)=>({
            ...prevState,
            requiredMonth : "",
            buyingFunds: 0,
            sellingFunds: 0,
            netBuying: 0,
            netSelling: 0,
            netBuyingSellingDifference:0,
            isModalApiInProgress: true
        }))
    }

    const getDataForPopUp =(date,industry)=>{
        let formattedDate=moment(date,"MMM-YYYY").endOf('month').format("YYYY-MM-DD")
        getNetBuyingSellingPopUpData(formattedDate,encodeURIComponent(industry)).then((res) => {
            if (res?.success) {
                if (!isEmpty(res?.data?.data)){
                    setPopUpModalData((prevState)=>({
                        ...prevState,
                        requiredMonth : date,
                        buyingFunds: res?.data?.data?.buyingFundsCount,
                        sellingFunds: res?.data?.data?.sellingFundsCount,
                        netBuying: getFixedValuesAfterDecimal(res?.data?.data?.buyingFundsMarketValue, 2),
                        netSelling: getFixedValuesAfterDecimal(res?.data?.data?.sellingFundsMarketValue, 2),
                        netBuyingSellingDifference: getFixedValuesAfterDecimal(res?.data?.data?.marketValueChange, 2),
                        isModalApiInProgress: false
                    }))
                }
            }
        });
    }



    useEffect(() => {
        setUIState('');
        const date = props.currentMonthDate;
        let industryQuery = encodeURIComponent(sector);

        getAllIndustries()
            .then((res) => {
                // setIsLoading(false);
                if (res.success) {
                    setIndustries(res.data.data);
                    setUIState(industryConst.CONTENT_AVAILABLE);
                }else {
                    setUIState(industryConst.CONTENT_UNAVAILABLE);
                }
            });

        getIndustrySummaryData(date,industryQuery).then((res) => {
            if (res.success && !isEmpty(res.data?.data)) {
                setIndustryState((prevState)=>({
                    ...prevState,
                    fundHouseCount: res.data.data?.fundHouses?.length,
                    marketValue : setIndustryData(res.data.data),
                    fundSchemeCount: !isEmpty(res.data.data?.funds) ? res.data.data.funds?.length : [],

                }));
            }
        });

        getIndustryActivities(date, industryQuery).then((res)=>{
            if (res.success){
                setIndustryState((prevState)=>({
                    ...prevState,
                    activitiesData:res.data.data,
                    activitiesStateLoaded: true
                }))
            }else {
                setIndustryState((prevState)=>({
                    ...prevState,
                    activitiesStateLoaded: true
                }))
            }
        });

        getStockTrendForIndustry(date, industryQuery).then((res) => {
            if (res?.success) {
                setBarLineChartData(res.data);
            }
        })

    }, []);

    useEffect(() => {
        setUIState('');

        setTimeout(()=>{
            setUIState(stocksConst.CONTENT_AVAILABLE);
        },200)
    }, [props.isLGView,props.isXLView, props.isMDView]);

    const setIndustryData = (data) => {
        let numberOfFundsIncreasingValue = 0;
        let marketValueOfFundsIncreasingValue = 0;
        let numberOfFundsDecreasingValue = 0;
        let marketValueFundsDecreasingValue = 0;

        let numberOfFundHousesIncreasingValue = 0;
        let marketValueOfFundHousesIncreasingValue = 0;
        let numberOfFundHousesDecreasingValue = 0;
        let marketValueFundHousesDecreasingValue = 0;


        let totalAUM = 0;
        let totalAUMChange = 0;

        for (let i = 0; i < data.fundHouses?.length; i++) {
            let marketValue = data.fundHouses[i].market_value_change_mom;
            totalAUM += data.fundHouses[i].total_market_value;
            totalAUMChange += data.fundHouses[i].market_value_change;


        }

        return getFixedValuesAfterDecimal(totalAUM, 0)

    };

    const setBarLineChartData = (chartData) =>{
        let xAxis = [];
        let yAxisBar = [];
        let yAxisLine = [];
        let barColor = [];
        if (isEmpty(chartData)){
            return
        }

        chartData?.data.forEach((item)=>{
            xAxis.push(item?.month);
            yAxisBar.push(getFixedValuesAfterDecimal(filterNetBuyingSellingValue(item?.total_market_value_change_due_to_activity)));
            yAxisLine.push(getFixedValuesAfterDecimal(item?.total_market_value,2));
            if (item?.total_market_value_change_due_to_activity >=0){
                barColor.push(appTheme.appColor.success)
            }else {
                barColor.push(appTheme.appColor.danger)
            }

        });

        setIndustryState((prevState)=>({
            ...prevState,
            xAxis: xAxis,
            yAxisBar: yAxisBar,
            barColor: barColor,
            yAxisLine: yAxisLine
        }))
    };

    const refresh = () => {
        window.location.reload(true);
    };

    const handleTabChange = (name, value) => {
        setIndustryState((prev)=>({
            ...prev,
            tabValue: value
        }));
    };

    const handleChange = () => {
        if (industryState?.isDomLoaded){
            setIndustryState((prev)=>({
                ...prev,
                isDomLoaded:true
            }))

        }
    };

    if (isEmpty(UIState)) {
        return (
            <DLLoader type={'screen'} isVisible={true}/>
        );
    }

    return (
        <IndustryView
            industry={sector}
            {...props}
            refresh={refresh}
            {...industryState}
            handleTabChange={handleTabChange}
            handleChange={handleChange}

            {...popUpModalData}
            isModalOpen={isModalOpen}
            handleOpenModal={handleOpenModal}
            handleCloseModal={handleCloseModal}
            getDataForPopUp={getDataForPopUp}
        />
    );
}

Industry.propTypes = {};
const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    currentMonthDate: state.userState.currentMonthDate,
    profile: state.userState.profile,
    isMDView: state.appState.deviceInfo.isMDView,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isSMView: state.appState.deviceInfo.isSMView,
    isXSView: state.appState.deviceInfo.isXSView
});

export default connect(mapStateToProps, {})(Industry);
